<script lang="ts">
	import Chart from "chart.js/auto";
	import type { Chart as ChartInstance, ChartOptions } from "chart.js";
	import { formatCurrency } from "#lib/shared/formatters.js";
	import { onDestroy } from "svelte";

	let {
		data,
		datasets
	}: {
		data: Record<string, number>[];
		datasets: { label: string; key: string; color: string }[];
	} = $props();

	let chartCanvas: HTMLCanvasElement;
	let chartInstance: ChartInstance | undefined = undefined;
	const chartLabels = $derived(data.map((item) => `Year ${item.year}`));

	const chartDatasets = $derived(
		datasets.map((ds) => ({
			label: ds.label,
			data: data.map((item) => item[ds.key]),
			borderColor: ds.color,
			borderWidth: 1
		}))
	);

	const chartOptions: ChartOptions<"line"> = {
		scales: {
			y: {
				title: {
					display: true,
					text: "Investment Value"
				}
			}
		},
		plugins: {
			tooltip: {
				mode: "x",
				callbacks: {
					label: (tooltipItem) => {
						return `${tooltipItem.dataset.label}: ${formatCurrency(tooltipItem.parsed.y)}`;
					},
					labelColor: (context) => {
						return {
							borderColor:
								typeof context?.dataset?.borderColor === "string"
									? context.dataset.borderColor
									: "transparent",
							backgroundColor:
								typeof context?.dataset?.backgroundColor === "string"
									? context.dataset.backgroundColor
									: "transparent",
							borderRadius: 2
						};
					}
				}
			},
			legend: {
				display: true,
				position: "bottom",
				align: "center",
				labels: {
					usePointStyle: true,
					pointStyle: "circle",
					boxHeight: 5,
					boxWidth: 5
				}
			}
		}
	};

	$effect(() => {
		const context = {
			chartCanvas,
			chartLabels,
			chartDatasets
		};

		if (!chartInstance) {
			chartInstance = new Chart(context.chartCanvas, {
				type: "line",
				data: {
					labels: context.chartLabels,
					datasets: context.chartDatasets
				},
				options: chartOptions
			});
		} else {
			chartInstance.data = {
				labels: context.chartLabels,
				datasets: context.chartDatasets
			};
			chartInstance.update();
		}
	});

	onDestroy(() => {
		chartInstance?.destroy();
	});
</script>

<canvas bind:this={chartCanvas} id="myChart"></canvas>
